import { find, register } from '../../../../Javascript/Utils'

const component = el => {
  const componentPrefix = el.dataset.componentprefix
  const consentCheckBox = find(`.${componentPrefix}checkBox`, el)
  const consentPlayButton = find(`.${componentPrefix}playButton`, el)

  consentCheckBox.onclick = function () {
    consentPlayButton.classList.toggle('hidden')
  }

  consentPlayButton.onclick = function () {
    el.style.display = 'none'
  }
}

register('mediaConsent', component)
